import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { bindActionCreators } from "redux";
import { View, Ellipsis, Menu } from "@zendesk/self-service-components";
import EllipsisIcon from "@zendesk/garden-svg-icons/src/26-ellipsis.svg";
import { connect } from "react-redux";
import classnames from "classnames";
import t from "@zendesk/client-i18n-tools";
import { Tag } from "@zendeskgarden/react-tags";
import * as actions from "../../../../actions/userSegment";
import styles from "./index.css";

export class UserSegment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
    };

    this.onMenuOpen = this.onMenuOpen.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDuplicate = this.onDuplicate.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onMenuOpen() {
    this.setState({ isMenuOpen: true });
  }

  onMenuClose() {
    this.setState({ isMenuOpen: false });
  }

  onEdit(value, e) {
    e && e.stopPropagation();

    const {
      userSegment: { id },
      editUserSegment,
    } = this.props;

    editUserSegment(id);
  }

  onDuplicate(value, e) {
    e.stopPropagation();

    const { userSegment, duplicateUserSegment } = this.props;
    const newUserSegment = {
      name: `${userSegment.name} copy`,
      user_type: userSegment.user_type,
      tags: [...userSegment.tags],
      organization_ids: [...userSegment.organization_ids],
      group_ids: [...userSegment.group_ids],
    };

    duplicateUserSegment(userSegment.id, newUserSegment);
  }

  onDelete(value, e) {
    e.stopPropagation();

    const {
      userSegment: { id },
      deleteUserSegment,
    } = this.props;

    deleteUserSegment(id);
  }

  render() {
    const {
      userSegment: { name, built_in: builtIn, id },
    } = this.props;

    const { isMenuOpen } = this.state;

    return (
      <View
        tabIndex={0}
        className={classnames(styles.userSegment, {
          [styles.activeUserSegment]: isMenuOpen,
        })}
        onEnter={this.onEdit}
        onClick={this.onEdit}
        testId="user-segment-row"
      >
        <View tabIndex={1} className={styles.header}>
          <View className={styles.name}>
            <Ellipsis>{name}</Ellipsis>
          </View>
          {builtIn && (
            <View className={styles.builtInLabelContainer}>
              <Tag
                className={styles.builtInLabel}
                type="blue"
                data-test-id="built-in-label"
              >
                {t("knowledge-user-segments.userSegment.builtIn")}
              </Tag>
            </View>
          )}

          <Menu
            testId="user-segment-row-menu"
            dir={t.dir}
            size="small"
            onOpen={this.onMenuOpen}
            onClose={this.onMenuClose}
            trigger={
              <a
                aria-label={t(
                  "knowledge-user-segments.list.userSegment.ariaLabel"
                )}
                onBlur={this.onBlur}
                tabIndex={0}
                className={styles.trigger}
                id={id}
                data-test-id="user-segment-row-menu-trigger"
              >
                <EllipsisIcon />
              </a>
            }
          >
            <Menu.Item onClick={this.onEdit} testId="user-segment-row-edit">
              {builtIn
                ? t("knowledge-user-segments.list.userSegment.view")
                : t("knowledge-user-segments.list.userSegment.edit")}
            </Menu.Item>
            <Menu.Item
              onClick={this.onDuplicate}
              testId="user-segment-row-duplicate"
            >
              {t("knowledge-user-segments.list.userSegment.duplicate")}
            </Menu.Item>
            {!builtIn && (
              <Menu.Item
                onClick={this.onDelete}
                testId="user-segment-row-delete"
              >
                <span className={styles.delete}>
                  {t("knowledge-user-segments.list.userSegment.delete")}
                </span>
              </Menu.Item>
            )}
          </Menu>
        </View>
      </View>
    );
  }
}

UserSegment.propTypes = {
  userSegment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    built_in: PropTypes.bool.isRequired,
  }).isRequired,
  deleteUserSegment: PropTypes.func,
  duplicateUserSegment: PropTypes.func,
  editUserSegment: PropTypes.func,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserSegment);



// WEBPACK FOOTER //
// ./src/components/UserSegments/components/UserSegment/index.js